import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/about', label: 'About' },
    { path: '/process', label: 'Process' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3">
            <div className="text-2xl font-bold text-[#0E3A5D]">
              <span className={`${isScrolled ? 'text-[#0E3A5D]' : 'text-white'}`}>DVS</span>
              <span className={`${isScrolled ? 'text-[#4FB3D9]' : 'text-[#4FB3D9]'}`}> Power Washing</span>
            </div>
          </Link>

          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? isScrolled
                      ? 'text-[#0E3A5D]'
                      : 'text-white'
                    : isScrolled
                    ? 'text-gray-700 hover:text-[#0E3A5D]'
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:2146368343"
              className="bg-[#4FB3D9] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#3A9DC4] transition-colors whitespace-nowrap flex items-center space-x-2"
            >
              <i className="ri-phone-fill"></i>
              <span>(214) 636-8343</span>
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2 ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-6 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-2 text-sm font-medium ${
                  location.pathname === link.path
                    ? 'text-[#0E3A5D]'
                    : 'text-gray-700 hover:text-[#0E3A5D]'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:2146368343"
              className="block bg-[#4FB3D9] text-white px-6 py-3 rounded-lg font-semibold text-center whitespace-nowrap"
            >
              <i className="ri-phone-fill mr-2"></i>
              (214) 636-8343
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
